<template>
  <div class="wrapper">
    <div class="content">
      <h1 class="mt-1">Terms of Service</h1>
      <div class="marker"></div>
      <h5 class="mt-2">Effective date: October 1, 2020</h5>

      <h2>Terms</h2>
      <p>
        By accessing this web site, you are agreeing to be bound by these web site Terms and
        Conditions of Use, our
        <a href="/privacy">Privacy Policy</a>
        , all applicable laws and regulations, and agree that you are responsible for compliance
        with any applicable local laws. If you do not agree with any of these terms, you are
        prohibited from using or accessing this site. The materials contained in this web site are
        protected by applicable copyright and trade mark law.
      </p>

      <h2>Use License</h2>
      <p>
        Permission is granted to temporarily download one copy of the materials (information or
        software) on AEC Works' web site for personal, non-commercial transitory viewing only. This
        is the grant of a license, not a transfer of title, and under this license you may not:
      </p>
      <ul class="mt-2 mb-2">
        <li class="ml-1">
          <p>• Modify or copy the materials</p>
        </li>
        <li class="ml-1">
          <p>
            • Use the materials for any commercial purpose, or for any public display (commercial or
            non-commercial)
          </p>
        </li>
        <li class="ml-1">
          <p>
            • Attempt to decompile or reverse engineer any software contained on AEC Works' web site
          </p>
        </li>
        <li class="ml-1">
          <p>• Remove any copyright or other proprietary notations from the materials; or</p>
        </li>
        <li class="ml-1">
          <p>
            • Transfer the materials to another person or "mirror" the materials on any other
            server.
          </p>
        </li>
      </ul>
      <p>
        This license shall automatically terminate if you violate any of these restrictions and may
        be terminated by AEC Works at any time. Upon terminating your viewing of these materials or
        upon the termination of this license, you must destroy any downloaded materials in your
        possession whether in electronic or printed format.
      </p>
      <h2>Disclaimer</h2>
      <p>
        The materials on AEC Works' web site are provided "as is". AEC Works makes no warranties,
        expressed or implied, and hereby disclaims and negates all other warranties, including
        without limitation, implied warranties or conditions of merchantability, fitness for a
        particular purpose, or non-infringement of intellectual property or other violation of
        rights. Further, AEC Works does not warrant or make any representations concerning the
        accuracy, likely results, or reliability of the use of the materials on its Internet web
        site or otherwise relating to such materials or on any sites linked to this site.
      </p>
      <h2>Limitations</h2>
      <p>
        In no event shall AEC Works or its suppliers be liable for any damages (including, without
        limitation, damages for loss of data or profit, or due to business interruption,) arising
        out of the use or inability to use the materials on AEC Works' Internet site, even if AEC
        Works or an authorized representative has been notified orally or in writing of the
        possibility of such damage. Because some jurisdictions do not allow limitations on implied
        warranties, or limitations of liability for consequential or incidental damages, these
        limitations may not apply to you.
      </p>

      <h2>Revisions and Errata</h2>
      <p>
        The materials appearing on AEC Works' web site could include technical, typographical, or
        photographic errors. AEC Works does not warrant that any of the materials on its web site
        are accurate, complete, or current. AEC Works may make changes to the materials contained on
        its web site at any time without notice. AEC Works does not, however, make any commitment to
        update the materials.
      </p>

      <h2>Links</h2>
      <p>
        AEC Works has not reviewed all of the sites linked to its Internet web site and is not
        responsible for the contents of any such linked site. The inclusion of any link does not
        imply endorsement by AEC Works of the site. Use of any such linked web site is at the user's
        own risk.
      </p>

      <h2>Copyright / Takedown</h2>
      <p>
        Users agree and certify that they have rights to share all content that they post on
        aec.works — including, but not limited to, information posted in articles, discussions, and
        comments. This rule applies to prose, code snippets, collections of links, etc. Regardless
        of citation, users may not post copy and pasted content that does not belong to them. Users
        assume all risk for the content they post, including someone else's reliance on its
        accuracy, claims relating to intellectual property, or other legal rights. If you believe
        that a user has plagiarized content, misrepresented their identity, misappropriated work, or
        otherwise run afoul of DMCA regulations, please email
        <a href="mailto:team@aec.works">team@aec.works</a>
        . AEC Works may remove any content users post for any reason.
      </p>

      <h2>Site Terms of Use Modifications</h2>
      <p>
        AEC Works may revise these terms of use for its web site at any time without notice. By
        using this web site you are agreeing to be bound by the then current version of these Terms
        and Conditions of Use.
      </p>

      <h2>AEC Works Trademarks and Logos Policy</h2>
      <p>
        All uses of the AEC Works logo, AEC Works badges, brand slogans, iconography, and the like,
        may only be used with express permission from AEC Works. AEC Works reserves all rights, even
        if certain assets are included in AEC Works open source projects. Please contact
        <a href="mailto:team@aec.works">team@aec.works</a>
        with any questions or to request permission.
      </p>

      <h2>Reserved Names</h2>
      <p>
        AEC Works has the right to maintain a list of reserved names which will not be made publicly
        available. These reserved names may be set aside for purposes of proactive trademark
        protection, avoiding user confusion, security measures, or any other reason (or no reason).
      </p>

      <p>
        Additionally, AEC Works reserves the right to change any already-claimed name at its sole
        discretion. In such cases, AEC Works will make reasonable effort to find a suitable
        alternative and assist with any transition-related concerns.
      </p>

      <h2 class="mb-1 mt-3 mt-1">Content Policy</h2>
      <p>
        The following policy applies to comments, articles, and all other works shared on the AEC
        Works platform:
      </p>
      <ul class="mt-2 mb-2">
        <li class="ml-1">
          <p>
            • Users must make a good-faith effort to share content that is on-topic, of
            high-quality, and is not designed primarily for the purposes of promotion or creating
            backlinks.
          </p>
        </li>
        <li class="ml-1">
          <p>
            • Posts must contain substantial content — they may not merely reference an external
            link that contains the full post.
          </p>
        </li>
        <li class="ml-1">
          <p>
            • If a post contains affiliate links, that fact must be clearly disclosed. For instance,
            with language such as: “This post includes affiliate links; I may receive compensation
            if you purchase products or services from the different links provided in this article.”
          </p>
        </li>
      </ul>
      <p>
        AEC Works reserves the right to remove any content that it deems to be in violation of this
        policy at its sole discretion. Additionally, AEC Works reserves the right to restrict any
        user’s ability to participate on the platform at its sole discretion.
      </p>

      <h2>Governing Law</h2>
      <p>
        Any claim relating to AEC Works's web site shall be governed by the laws of the State of New
        York without regard to its conflict of law provisions.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsOfService',
  metaInfo: {
    title: 'Terms of Service',
  },
}
</script>
